import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 删除消息
 * @param {number} id - 消息ID
 * @returns {Promise}
 */
export const delete_message = (id) => {
  // 后端使用DELETE方法，参数从Body JSON传递
  return api.delete(`${ApiEndpointConstants.DELETE_MESSAGE}`, {
    data: { id },
  });
};

